module.exports = __webpack_public_path__ + "img/SkillDevelopment.a6e7dc49.svg";